"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SwitchAuthType = function (_a) {
    var authType = _a.authType, setAuthType = _a.setAuthType, geo = _a.geo;
    var t = (0, next_intl_1.useTranslations)('translation');
    var lang = (0, next_intl_1.useLocale)();
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(geo === 'UZ' || lang === 'uz' ? styles_module_scss_1.default.reversed : '') },
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.tab, " ").concat(authType === 'email' ? styles_module_scss_1.default.active : ''), onClick: function () {
                setAuthType('email');
            } }, t('email')),
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.tab, " ").concat(authType === 'phone' ? styles_module_scss_1.default.active : ''), onClick: function () {
                setAuthType('phone');
            } }, t('phone'))));
};
exports.default = SwitchAuthType;
